const style = {
  spacedBetweenRow: {
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  simpleRow: {
    flexDirection: 'row',
    display: 'flex',
    marginBottom: 10,
  },
  simpleColumn: {
    flexDirection: 'column',
    display: 'flex',
  },
  filterButton: {
    width: '100%',
  },
  clickable: {
    cursor: 'pointer',
  },
};

export default style;
